import { render } from "./App.vue?vue&type=template&id=5db4c0fc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5db4c0fc&lang=css"

import exportComponent from "/Users/pinball73/RaceBonus/rbonus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__